import React, { useState } from 'react';
import { Paper } from '@material-ui/core';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertFromRaw } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useTranslation } from 'react-i18next';

const RTEFormField = (props) => {
  const { i18n } = useTranslation();
  const [editorState, setEditorState] = useState(
    () => {
      if (props.schema.signature && Object.keys(props.schema.signature).length) { // check if signatue is present
        return EditorState.createWithContent(convertFromRaw(props.schema.signature));
      }
      return EditorState.createEmpty();
    }
  );

  const onChange = (editorState) => {
    setEditorState(editorState);
    const data = props.schema.toolbar
      ? customConvert(editorState.getCurrentContent())
      : editorState.getCurrentContent().getPlainText('\u0001');
    props.onChange(data);
  };

  return (
    <Paper style={{ padding: 10 }}>
      <Editor
        editorState={editorState}
        toolbarClassName='toolbarClassName'
        wrapperClassName='wrapperClassName'
        editorClassName='editorClassName'
        onEditorStateChange={onChange}
        toolbarStyle={(props.schema.toolbar) ? {} : { display: 'none' }}
        localization={{ locale: i18n.language }}
      />
    </Paper>
  );
};

const customConvert = (contentState) => {
  return convertToHTML({
    styleToHTML: (style) => {
      switch (style) {
        case 'STRIKETHROUGH':
          return <s />;
        case 'SUPERSCRIPT':
          return <sup />;
        case 'SUBSCRIPT':
          return <sub />;
        default:
          if (style.startsWith('fontsize')) { return <span style={{ 'font-size': style.replace('fontsize-', '') + 'px' }} />; }

          if (style.startsWith('fontfamily')) { return <span style={{ 'font-family': style.replace('fontfamily-', '') }} />; }

          if (style.startsWith('color-rgb')) { return <span style={{ 'color': style.replace('color-', '') }} />; }

          if (style.startsWith('bgcolor-rgb')) { return <span style={{ 'background-color': style.replace('bgcolor-', '') }} />; }
      }
    },
    blockToHTML: (block) => {
      if (block.data['text-align']) {
        const style = { 'text-align': block.data['text-align'] };
        switch (block.type) {
          case 'unstyled':
            return <p style={style} />;
          case 'header-one':
            return <h1 style={style} />;
          case 'header-two':
            return <h2 style={style} />;
          case 'header-three':
            return <h3 style={style} />;
          case 'header-four':
            return <h4 style={style} />;
          case 'header-five':
            return <h5 style={style} />;
          case 'header-six':
            return <h6 style={style} />;
          case 'blockquote':
            return <blockquote style={style} />;
          case 'code':
            return <code style={style} />;
          default:
            return <p style={style} />;
        }
      }
    },
    entityToHTML: (entity, originalText) => {
      switch (entity.type) {
        case 'LINK':
          if (entity.data.targetOption) {
            return <a href={entity.data.url} target={entity.data.targetOption}>{originalText}</a>;
          } else {
            return <a href={entity.data.url}>{originalText}</a>;
          }
        case 'IMAGE':
          let alignment = 'center';
          if (entity.data.alignment === 'left') alignment = 'start';
          else if (entity.data.alignment === 'right') alignment = 'end';
          return (
            <div style={{ display: 'flex', justifyContent: alignment }}>
              <img src={entity.data.src} alt='img' width={entity.data.width} height={entity.data.height} />
            </div>
          );
        case 'EMBEDDED_LINK':
          return <embed src={entity.data.src} width={entity.data.width} height={entity.data.height} />;
        default:
          return originalText;
      }
    }
  })(contentState);
};

export default RTEFormField;
